var _path, _path2, _path3, _ellipse, _ellipse2, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoodPack6 = function SvgGoodPack6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.027 69.888c55.284 13.621 40.395 54.417 26.039 73.112 16.025 21.633-1.335 35.721-12.018 40.061-9.615 53.682-52.747 43.734-73.112 32.049-28.844 4.808-42.064-14.689-45.069-25.038-36.856-6.41-36.722-37.39-32.049-52.079-25.639-42.465 10.683-63.097 32.05-68.105 13.62-37.657 45.736-24.37 60.091-13.02 20.832-14.422 38.058 2.671 44.068 13.02Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.368 139.775c10.753 9.818 30.856 31.698 25.245 40.674-5.61 8.976-32.258-4.675-44.881-12.623m0 0c1.87-4.208 4.208-12.342-1.402-11.22-5.61 1.122-1.999 3.74-.597 5.61m1.999 5.61c-.935-4.208-3.927-11.781-8.415-8.415-4.488 3.366 1.563 4.675 4.368 5.61m4.047 2.805c-2.805-2.337-8.695-6.171-9.817-2.805-1.116 3.348.874 6.695 4.207 4.392m5.61-1.587 11.221-14.025m-14.026 12.623c-1.003 1.433-1.948 2.397-2.805 2.989m5.61-.184c0 1.058-1.121 2.576-5.61.184",
    stroke: "#000",
    strokeWidth: 1.964,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.765 179.704c8.8 1.885 28.287 1.508 35.831-15.087",
    stroke: "#fff",
    strokeWidth: 7.543,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.134,
    cy: 123.471,
    rx: 22.63,
    ry: 30.174,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.71,
    cy: 123.471,
    rx: 22.63,
    ry: 30.174,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.134,
    cy: 123.471,
    r: 7.543,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m168.253 114.041-12.967 7.78c-2.552 1.531-2.408 5.277.254 6.608l12.713 6.356",
    stroke: "#000",
    strokeWidth: 7.543,
    strokeLinecap: "round"
  })));
};
export default SvgGoodPack6;